export default `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 1024 1024">
    <path d="M640 341.333v-341.333h-256v341.333h-256l379.733 426.667 384-426.667h-251.733zM64 768h894.293q9.387 0 16.213 6.4t6.827 14.933v234.667h-938.667v-234.667q0-9.387 5.973-15.36t15.36-5.973zM896 853.333h-85.333v42.667h85.333v-42.667z"></path>
</svg>
`;
